// extracted by mini-css-extract-plugin
module.exports = {"presenterToolsSelectionHolder":"PresenterToolsSelection_presenterToolsSelectionHolder__7hthY"};